module.exports = __webpack_public_path__ + "static/media/plant-in-pot.35408b62.jpg";